import React from 'react'
import { Button } from 'react-bootstrap';
import { CSVLink } from "react-csv";

function ExportReport({
  data, 
  fileName, 
}) {

  return (
    <CSVLink data={data} filename={fileName + "_" + Date.now() + ".csv"}>
      <Button>Export to CSV</Button>
    </CSVLink>
  )
}

export default ExportReport